import type { GQLExtension } from '../web-client/graphql/types';
import { isCustomUI } from './isCustomUI';

export const getExtensionType = (extension: GQLExtension) => {
	const { properties } = extension;

	if (properties?.bodyType === 'rich-text') {
		return 'bodiedExtension';
	} else if (properties?.layout === 'inline' && !isCustomUI(extension)) {
		return 'inlineExtension';
	}
	return 'extension';
};
